export default __webpack_public_path__ + "static/media/ferramentas-fita.cd3358f1.png";